import { useState } from 'react';
export const useForceUpdate = () => {
    const [updater, setUpdater] = useState(0);
    return { updater, forceUpdate: () => setUpdater((value) => value + 1) };
};
